// src/services/environmentalApi.js
import apiService from './apiService';

const environmentalApi = {
  analyze: (windowDays = 90) => apiService.post('/environmental/analyze', { windowDays }),
  getMine: () => apiService.get('/environmental/mine'),
  getAll: () => apiService.get('/environmental'), // admin only
};

export default environmentalApi;
